import { render, staticRenderFns } from "./SavedCards.vue?vue&type=template&id=0fc4e5f8&scoped=true"
import script from "./SavedCards.vue?vue&type=script&lang=js"
export * from "./SavedCards.vue?vue&type=script&lang=js"
import style0 from "./SavedCards.vue?vue&type=style&index=0&id=0fc4e5f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc4e5f8",
  null
  
)

export default component.exports